type getIsProductAdminFromQueryParam = {
	readonly user?: {
		readonly confluence?: {
			readonly operations?: ReadonlyArray<
				| {
						readonly operation?: string | null;
						readonly targetType?: string | null;
				  }
				| null
				| undefined
			> | null;
		} | null;
	} | null;
} | null;

export const getIsProductAdminFromQuery = (queryData?: getIsProductAdminFromQueryParam): boolean =>
	Boolean(
		queryData?.user?.confluence?.operations?.some(
			(o) => o?.operation === 'administer' && o?.targetType === 'application',
		),
	);
